// extracted by mini-css-extract-plugin
module.exports = {"field":"awo_jn","headerText":"awo_ak1","inputField":"awo_awp","errorInput":"awo_ah6","error":"awo_jz"};